/**
 * Display formatting helpers. Pure functions, no I/O.
 */

import type { Surah } from '@/types/domain';

export function surahAyahRef(surahId: number, ayahNumber: number): string {
  return `${surahId}:${ayahNumber}`;
}

export function juzLabel(juz: number | null | undefined): string | null {
  return juz ? `Juz ${juz}` : null;
}

export function revelationLabel(
  revelationType: Surah['revelation_type'],
): string {
  // The CHECK constraint values aren't pinned yet (see DATABASE_MAP.md §7).
  // We capitalize whatever we get, falling back to the raw value.
  if (!revelationType) return '';
  const v = revelationType.toLowerCase();
  if (v === 'meccan') return 'Meccan';
  if (v === 'medinan') return 'Medinan';
  return revelationType.charAt(0).toUpperCase() + revelationType.slice(1);
}

/** Pad a surah or ayah number to 3 digits for sorting / URLs / file paths. */
export function pad3(n: number): string {
  return String(n).padStart(3, '0');
}
